import { render, staticRenderFns } from "./PromotionsView.vue?vue&type=template&id=6c274fc6"
import script from "./PromotionsView.vue?vue&type=script&lang=ts"
export * from "./PromotionsView.vue?vue&type=script&lang=ts"
import style0 from "./PromotionsView.vue?vue&type=style&index=0&id=6c274fc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports